import { Injectable } from '@angular/core';

import { AbstractDataLayerService } from '@abstract-services/data-layer/1.0/data-layer.abstract-service';
import { DataLayerCustomDimensions } from '@constants/custom-dimensions/index';

type FullCustomDimensionsSet = {
  [key in DataLayerCustomDimensions]: string | undefined;
};

export interface CustomDimensionsPartial {
  [key: string]: string;
}

@Injectable({
  providedIn: 'root',
})
export class DataLayerService implements AbstractDataLayerService {
  private currentSet: FullCustomDimensionsSet;
  private constantDimensions: Record<string, unknown>;

  constructor() {
    this.generateEmptyDimensionsSet();
    this.constantDimensions = {};
  }

  set dimensions(dimensions: CustomDimensionsPartial) {
    Object.keys(DataLayerCustomDimensions)
      .map((key) => DataLayerCustomDimensions[key])
      .forEach((key) => {
        this.currentSet[key] = dimensions[key] || this.constantDimensions[key];
      });
  }

  trigger() {
    (window as any).dataLayer.push(this.currentSet);
  }

  private generateEmptyDimensionsSet() {
    this.currentSet = {
      [DataLayerCustomDimensions.MentionedBrand]: undefined,
      [DataLayerCustomDimensions.PageCategory]: undefined,
      [DataLayerCustomDimensions.WordsCount]: undefined,
      [DataLayerCustomDimensions.Language]: undefined,
    };
  }
}
